var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ax-unread-mentions-indicator",attrs:{"title":"You have unread mentions"}},[_c('AxIcon',{staticClass:"unread-mentions-dot",attrs:{"name":"dot"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }